// Native
import { useState } from "react"

// Components
import { Badge, ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { IconButton, Section, Table, Tag } from "components"

// Config
import { Moment } from "config"

// Hooks
import { useConsultantAnticipationHistory } from "hooks"
import { Mask } from "config"

export default function Anticipations({ data:consultant }){

    const [ page, setPage ] = useState(1)
    const history = useConsultantAnticipationHistory(consultant.data?.id, page)

    const columns = [
        { children: 'Tipo' }, 
        { children: 'Pin' }, 
        { children: 'Qualificáveis', isNumeric: true }, 
        { children: 'Acima da VME', isNumeric: true }, 
        { children: 'Data', isNumeric: true }
    ]

    return(
    <>
        <Section title="Histórico de Antecipações">
            <ButtonGroup size="xs" isDisabled={history.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={history.isFetching} onClick={history.refetch} />
            </ButtonGroup>
        </Section>

        <Table columns={columns} setPage={setPage} meta={history.data?.meta} loading={history.isLoading}>
            { history.data?.data?.map(item => <Item key={item.id} data={item} />) }
        </Table>
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td><Tag size="sm" children={item.type === 1 ? 'Sistema' : 'Consultor'} /></Td>
        <Td><Badge children={item.career.title} /></Td>
        <Td><Badge colorScheme="teal" children={Mask.price(item.qualified)} /></Td>
        <Td><Badge colorScheme="orange" children={Mask.price(item.overflow)} /></Td>
        <Td isNumeric fontSize="xs" children={Moment(item.created_at).format('LLL')} />
    </Tr>
)